import React from "react";
import { FaWhatsapp } from "react-icons/fa";
import { WHATSAPP_URL } from "@/lib/site";

export const WhatsappButton = ({
  label = "Agendar pelo WhatsApp",
  variant = "pink",
  size = "lg",
  className = "",
  testId,
}) => {
  const base =
    "btn-shine group inline-flex items-center justify-center gap-3 rounded-full font-sans font-semibold tracking-wide transition-all duration-300 ease-out active:scale-[0.97] select-none";
  
  const sizes = {
    lg: "px-8 py-4 text-base",
    md: "px-6 py-3 text-sm",
    sm: "px-4 py-2 text-xs",
  };

  const variants = {
    pink: "bg-clinic-rose text-white hover:bg-clinic-roseDeep hover:-translate-y-0.5 shadow-glow-rose hover:shadow-[0_16px_40px_-8px_rgba(184,112,104,0.7)]",
    gold: "bg-clinic-gold text-clinic-ink hover:bg-[#b8913d] hover:-translate-y-0.5 shadow-glow-gold hover:text-white",
    dark: "bg-clinic-ink text-white hover:bg-[#3b302c] hover:-translate-y-0.5 shadow-soft",
    soft: "bg-clinic-pinkSoft text-clinic-ink hover:bg-clinic-pink hover:-translate-y-0.5",
    outline:
      "border border-clinic-rose/50 text-clinic-rose bg-white/60 backdrop-blur-sm hover:bg-clinic-rose hover:text-white hover:border-transparent hover:-translate-y-0.5 shadow-sm",
  };

  return (
    <a
      href={WHATSAPP_URL}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={testId}
      className={`${base} ${sizes[size]} ${variants[variant]} ${className}`}
    >
      <FaWhatsapp className="h-5 w-5 shrink-0 transition-transform duration-300 group-hover:rotate-12 group-hover:scale-110" />
      <span>{label}</span>
    </a>
  );
};

